import type { ReactNode } from 'react';
import { nextStep, previousStep } from './clientRequestSlice';
import { useAppDispatch } from '../../../configuration/setup/hooks';

interface Props {
    previousStepDisabled?: boolean;
    nextStepDisabled: boolean;
    children?: ReactNode;
    className?: string;
}

export const NavigationButtons = (props: Props) => {
    const dispatch = useAppDispatch();
    const { previousStepDisabled = false, nextStepDisabled, children, className } = props;
    return (
        <div className={className ?? 'btn-toolbar pull-right margin-top-5pct'}>
            {children}
            <button
                type={'button'}
                className={'btn btn-primary'}
                onClick={() => dispatch(previousStep())}
                disabled={previousStepDisabled}
            >
                Previous
            </button>
            <button
                type={'button'}
                className={'btn btn-primary'}
                onClick={() => dispatch(nextStep())}
                disabled={nextStepDisabled}
            >
                Next
            </button>
        </div>
    );
};
